import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  token: null,
  signInRes: null,
  signUpRes: null,
  resendOtpRes: null,
  confirmOtpRes: null,
  confirmSignUpRes: null,
  error: null,
  loading: false,
  isAuthCheck: false,
};

//Login
const signInStart = (state: any, action: any) => {
  return updateObject(state, { signInRes: null, error: null, loading: true });
};

const signInSuccess = (state: any, action: any) => {
  return updateObject(state, {
    signInRes: action.signInRes,
    error: null,
    loading: false,
  });
};

const signInFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Confirm OTP
const confirmOtpStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const confirmOtpSuccess = (state: any, action: any) => {
  return updateObject(state, {
    confirmOtpRes: action.confirmOtpRes,
    error: null,
    loading: false,
  });
};

const confirmOtpFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Confirm Sign-Up otp
const confirmSignUpStart = (state: any, action: any) => {
    return updateObject(state, { error: null, loading: true });
  };
  
  const confirmSignUpSuccess = (state: any, action: any) => {
    return updateObject(state, {
      confirmSignUpRes: action.confirmSignUpRes,
      error: null,
      loading: false,
    });
  };
  
  const confirmSignUpFail = (state: any, action: any) => {
    return updateObject(state, {
      error: action.error,
      loading: false,
    });
  };

// Register
const signUpStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const signUpSuccess = (state: any, action: any) => {
  return updateObject(state, {
    signUpRes: action.signUpRes,
    error: null,
    loading: false,
  });
};

const signUpFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Logout
const signInLogout = (state: any, action: any) => {
  return updateObject(state, { token: null });
};

// ----------- Resend OTP ----------- //
const resendOtpStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const resendOtpSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const resendOtpFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// ----------- Terms and condition ----------- //
const termConditionStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const termConditionFinish = (state: any) => {
  return updateObject(state, { error: null, loading: false });
};

// ----------- Privacy Policy ----------- //
const privacyPolicyStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const privacyPolicyFinish = (state: any) => {
  return updateObject(state, { error: null, loading: false });
};

// ----------- Initialize Password Reset ----------- //
const initPasswordResetStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const initPasswordResetSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const initPasswordResetFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// ----------- Support Info ----------- //
const getSupportInfoStart = (state: any) => {
  return updateObject(state, { loading: true });
};

const getSupportInfoFinish = (state: any) => {
  return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.AUTH_LOGOUT:
      return signInLogout(state, action);
    case actionTypes.AUTH_LOGIN_START:
      return signInStart(state, action);
    case actionTypes.AUTH_LOGIN_SUCCESS:
      return signInSuccess(state, action);
    case actionTypes.AUTH_LOGIN_FAIL:
      return signInFail(state, action);
    case actionTypes.AUTH_REGISTER_START:
      return signUpStart(state, action);
    case actionTypes.AUTH_REGISTER_SUCCESS:
      return signUpSuccess(state, action);
    case actionTypes.AUTH_REGISTER_FAIL:
      return signUpFail(state, action);
    case actionTypes.RESEND_OTP_START:
      return resendOtpStart(state, action);
    case actionTypes.RESEND_OTP_SUCCESS:
      return resendOtpSuccess(state, action);
    case actionTypes.RESEND_OTP_FAIL:
      return resendOtpFailed(state, action);
    case actionTypes.AUTH_SIGNIN_CONFIRM_START:
      return confirmOtpStart(state, action);
    case actionTypes.AUTH_SIGNIN_CONFIRM_SUCCESS:
      return confirmOtpSuccess(state, action);
    case actionTypes.AUTH_SIGNIN_CONFIRM_FAIL:
      return confirmOtpFail(state, action);

    // Confirm Sign-Up otp
    case actionTypes.AUTH_SIGNIN_CONFIRM_START:
        return confirmSignUpStart(state, action);
    case actionTypes.AUTH_SIGNIN_CONFIRM_SUCCESS:
      return confirmSignUpSuccess(state, action);
    case actionTypes.AUTH_SIGNIN_CONFIRM_FAIL:
        return confirmSignUpFail(state, action);

    // term condition
    case actionTypes.AUTH_TERMS_CONDITIONS_START:
      return termConditionStart(state);
    case actionTypes.AUTH_TERMS_CONDITIONS_FINISH:
      return termConditionFinish(state);

    // term condition
    case actionTypes.AUTH_PRIVACY_POLICY_START:
      return privacyPolicyStart(state);
    case actionTypes.AUTH_PRIVACY_POLICY_FINISH:
      return privacyPolicyFinish(state);

    // Initialize Password Reset
    case actionTypes.INIT_PASSWORD_RESET_START:
      return initPasswordResetStart(state);
    case actionTypes.INIT_PASSWORD_RESET_FAIL:
      return initPasswordResetFailed(state, action);
    case actionTypes.INIT_PASSWORD_RESET_SUCCESS:
      return initPasswordResetSuccess(state);

    // Support Info
    case actionTypes.GET_SUPPORT_INFO_START:
      return getSupportInfoStart(state);
    case actionTypes.GET_SUPPORT_INFO_FINISH:
      return getSupportInfoFinish(state);

    default:
      return state;
  }
};

export default reducer;
